export const Route = {
	TIMELINE_WORKER: "/crm/timeline/worker/{worker}",
	TIMELINE_CONTACT: "/crm/timeline/contact/{contact}",
	TIMELINE_ACCOUNT: "/crm/timeline/account/{account}",
	TIMELINE_AGENCY: "/crm/timeline/agency/{agency}",
	TIMELINE_PROVIDER: "/crm/timeline/provider/{provider}",
	VIEW_PROPOSAL: "/proposals/{proposal}",
	VIEW_PROPOSALS: "/proposals",
	VIEW_PROPOSAL_SEND: "proposal/strategy/{proposal}",
	VIEW_CAMPAIGN: "/campaigns/{campaign}",
	VIEW_CAMPAIGNS: "/campaigns",
	VIEW_CAMPAIGN_MAP: "/campaign/map/{campaign}",
	VIEW_CONTACT: "/crm/contacts",
	VIEW_ELEMENT: "/elements/{element}",
	VIEW_AGENTES: "/crm/agent",
	VIEW_SUCURSALES: "/crm/subsidiary",
	VIEW_PROSPECTS: "/prospects",
	VIEW_PROSPECTS_HISTORICAL: "timeline/prospect/{id}",
	VIEW_AGENTS_HISTORICAL: "timeline/agent/{id}",
};
